module.exports = __webpack_public_path__ + "assets_1789874507493/img/guide_android.4b8e8721.png";